var trans = {
	'test': 'foo br',
	'ENTRAR_UC': 'ENTRAR',
	'ATUALIZAR': 'Atualizar',
	'SAIR': 'Sair',
	'OBSERVACOES': 'Observações',
	'DEBITAR': 'Debitar',
	'CANCELAR': 'Cancelar',
	'ROUPA': 'Roupa',
	'RESUMO': 'Resumo',
	'AREA': 'Área',
	'COLABORADOR_A': 'Colaborador(a)',
	'QTD_QUARTOS': 'Qtd. Quartos',
	'TEMPO_TOTAL_MIN': 'Tempo Total (min)',
	'ESTADO': 'Estado',
	'N_PESSOAS': 'Nº Pessoas',
	'CAMAS_EXTRA': 'Camas Extra',
	'NAO_INCOMODAR': 'Não Incomodar',
	'LIMPEZA_PRIORITARIA': 'Limpeza Prioritária',
	'ESTADO_RESERVA': 'Estado Reserva',
	'MUDAR_LENCOIS': 'Mudar Lençóis',
	'NAO': 'Não',
	'SIM': 'Sim',
	'BERCOS': 'Berços',
	'NAO_LIMPAR': 'Não Limpar',
	'TEMPO_MIN': 'Tempo (min)',
	'INICIO_UC': 'INÍCIO',
	'FIM_UC': 'FIM',
	'LIMPO_UC': 'LIMPO',
	'ROUPA_UC': 'ROUPA',
	'INSPECAO_UC': 'INSPEÇÃO',
	'PRECISA_DE_LIGACAO_A_INTERNET': 'Precisa de ligação à internet para aceder a esta funcionalidade.',
	'RESERVAS_NO_POST': 'Reservas "No Post" não permitem esta operação.',
	'OCORREU_UM_PROBLEMA_AO_TENTAR': 'Ocorreu um problema ao tentar enviar mensagem.',
	'LIMPO_C_ENTRADA': 'Limpo c/ Entrada',
	'LIMPO': 'Limpo',
	'SAIDA_C_ENTRADA': 'Saída c/ Entrada',
	'SUJO_C_ENTRADA': 'Sujo c/ Entrada',
	'SAIDA': 'Saída',
	'OCUPADO': 'Ocupado',
	'SUJO': 'Sujo',
	'SUJA': 'Suja',
	'EM_FALTA': 'Em Falta',
	'TOTAL': 'Total',
	'ARTIGO': 'Artigo',
	'QTD': 'Qtd.',
	'CONSUMO': 'Consumo',
	'QUEBRA': 'Quebra',
	'EXISTEM_ALTERACOES_NOS_CONSUMOS': 'Existem alterações nos consumos do quarto.',
	'EXISTEM_ALTERACOES_NAS_QUEBRAS': 'Existem alterações nas quebras do quarto.',
	'PRETENDE_AVANCAR': 'Pretende avançar?',
	'ESTADO_DO_QUARTO': 'Estado do Quarto',
	'AVALIACAO': 'Avaliação',
	'AVALIACAO_GERAL': 'Avaliação Geral',
	'AVALIACAO_MANUTENCAO': 'Manutenção',
	'AVALIACAO_LIMPEZA': 'Limpeza',
	'INSPECIONADO': 'Inspecionado',
	'O_CAMPO_AVALIACAO_E_OBRIGATORIO': 'O campo Avaliação geral é obrigatório.',
	'O_CAMPO_MANUTENCAO_E_OBRIGATORIO': 'O campo Manutenção é obrigatório.',
	'O_CAMPO_LIMPEZA_E_OBRIGATORIO': 'O campo Limpeza é obrigatório.',
	'QUANTIDADE': 'Quantidade',
	'NAO_EXISTE_ROUPA_ATRIBUIDA_PARA': 'Não existe roupa atribuída para esta área.',
	'BLOCO': 'Bloco',
	'PISO': 'Piso',
	'N_QUARTO': 'Nº Quarto',
	'ESTADO_LIMPEZA': 'Estado Limpeza',
	'QUARTOS': 'Quartos',
	'AVISO': 'Aviso',
	'ERRO': 'Erro',
	'PESQUISA' : 'Pesquisa',
	'REGIME': 'Regime',
	'CONFIRMAR': 'Confirmar',
	'AVANCAR': 'Avançar',
	'INSPECTION_NOT_SAVED_NO_INTERNET': 'A inspeção não foi guardada. Não tem ligação à internet.',
	'BREAKING_NOT_SAVED_NO_INTERNET': 'Débito de minibar não foi guardado. Não tem ligação à internet.',
	'PESQUISAR': 'Pesquisar',
	'FECHAR': 'Fechar',
	'RESET': 'Reset',
	'RESERVA': 'Reserva',
	'ADULTOS': 'Adultos',
	'CRIANCAS_4_12': 'Crianças 4-12',
	'CRIANCAS_0_3': 'Crianças 0-3',
	'NAO_NO_SHOW': 'Não foram encontradas reservas no estado "No Show".',
	'REPORT': 'Relatório',
	'NO_SHOW': 'No Show',
	'TIPOLOGIA': 'Tipología',
	'ESTADO_QUARTO': 'Estado Quarto',
	'HORA_INSPECAO_GOVERNANTA': 'Hora Inspeção Governanta',
	'HORA_INSPECAO_DIRECAO': 'Hora Inspeção Direção',
	'INSPECAO_GOVERNANTA': 'Inspeção Governanta',
	'INSPECAO_DIRECAO': 'Inspeção Direção',
	'O_CAMPO_OBSERVACAO_E_OBRIGATORIO':'O Campo \'Observações Quarto\' é obrigatório para o estado do quarto \'Manutenção\\Bloqueado\'',
	'OBSERVACOES_QUARTO':'Observações Quarto',
	'OBSERVACOES_INSPECAO': 'Observações Inspeção',
}
module.exports = trans;